import { Directive, ElementRef, AfterViewInit, Input } from "@angular/core";

@Directive({
    selector: '[scheduler-templates]',
    standalone: false
})
export class SchedulerTemplates implements AfterViewInit {
    constructor(private element: ElementRef) {
    }

    @Input('scheduler-templates')
    public schedulerTemplates: string;

    ngAfterViewInit(): void {
        this.element.nativeElement.innerHTML += `
        <!-- --------------- template definitions start --------------- -->
        <script id="ba-widgets-listviewbase-tpl" type="text/x-jquery-tmpl">
            <div class="list-viewport">
                <ul class="list-content"></ul>
            </div>
        </script>
        <script id="ba-widgets-scheduler-weekday-tpl" type="text/x-jquery-tmpl">
            <div class="daily-item">
                <div class="label"><span class="day"></span></div>
                <div class="phase-container"></div>
            </div>
        </script>
        <script id="ba-widgets-scheduler-exceptioncalendar-tpl" type="text/x-jquery-tmpl">
            <div class="scheduler-operation-button-group">
                <a class="operation-button ok" href="#">OK</a>
                <a class="operation-button cancel" href="#">Cancel</a>
            </div>
            <div class="calendar-widget">
                <div class="time-control">
                    <a href="#" class="operation-button prev"></a>
                    <a href="#" class="operation-button next"></a>
                    <span class="label month-year"></span>
                </div>
                <div class="calendar-table">
                    <div class="weekday-row">
                        <ul></ul>
                    </div>
                    <div class="month-days">
                        <ul class="week-of-year"></ul>
                        <ul class="dates"></ul>
                        <div class="bottom-line"></div>
                    </div>
                </div>
            </div>
        </script>
        <script id="ba-widgets-scheduler-dailyprofilebuttons-tpl" type="text/x-jquery-tmpl">
            <a class="operation-button copy" href="#">Copy</a>
            <a class="operation-button delete disabled" href="#">Delete</a>
        </script>
        <script id="ba-widgets-scheduler-weeklyoverview-tpl" type="text/x-jquery-tmpl">
            <div class="scheduler-operation-button-group">
                <a class="operation-button ok disabled" href="#">OK</a>
                <a class="operation-button cancel" href="#">Cancel</a>
            </div>

            <div class="scheduler-message">Scheduler is not available.</div>

            <div class="week-container">
                <div class="week-days-container"></div>
                <div class="hour-axis">
                    <span class="label">00</span>
                    <span class="label">06</span>
                    <span class="label">12</span>
                    <span class="label">18</span>
                    <span class="label">24</span>
                </div>
            </div>
        </script>
        <script id="ba-widgets-scheduler-exceptionprofilebuttons-tpl" type="text/x-jquery-tmpl">
            <a class="operation-button recurring" href="#">Recurring</a>
            <a class="operation-button range" href="#">Range</a>
            <a class="operation-button copy" href="#">Copy</a>
            <a class="operation-button delete disabled" href="#">Delete</a>
        </script>
        <script id="ba-widgets-scheduler-profilebase-tpl" type="text/x-jquery-tmpl">
            <div class="clearfix">
                <div class="scheduler-operation-button-group"></div>
            </div>
            <div class="daily-schedule-container">
                <div class="schedule-title"></div>
                <div class="adjust-mode-widget invisible">
                    <div class="indicator"></div>
                    <a class="operation-button down"></a>
                    <a class="operation-button up"></a>
                </div>
                <div class="schedule-table-layout-container">
                    <div class="schedule-table-border top"></div>
                    <div class="schedule-table"></div>
                    <div class="schedule-table-border bottom"></div>
                </div>
                <div class="hour-axis">
                    <span class="label">00</span>
                    <span class="label">06</span>
                    <span class="label">12</span>
                    <span class="label">18</span>
                    <span class="label">24</span>
                </div>
                <div class="adjust-time-widget invisible">
                    <span class="label hour adjusting">00</span>
                    <span class="label divider">:</span>
                    <span class="label minute">00</span>
                    <a href="#" class="operation-button minus"></a>
                    <a href="#" class="operation-button plus"></a>
                    <a href="#" class="operation-button text ok">OK</a>
                    <a href="#" class="operation-button text cancel">Cancel</a>
                </div>
            </div>
        </script>
        <script id="ba-widgets-scheduler-exceptionprofile-adjuster-tpl" type="text/x-jquery-tmpl">
            <div class="adjust-mode-widget invisible">
                <div class="indicator"></div>
                <a class="operation-button down"></a>
                <a class="operation-button up"></a>
            </div>
            <div class="adjust-time-widget">
                <a href="#" class="operation-button text ok">OK</a>
                <a href="#" class="operation-button text cancel">Cancel</a>
            </div>
        </script>
        <script id="ba-widgets-scheduler-exceptionlistitem-tpl" type="text/x-jquery-tmpl">
            <div class="item-line">
                <span class="item-title"></span>
            </div>
        </script>
        <script id="ba-widgets-scheduler-exceptiondialogcalendarref-tpl" type="text/x-jquery-tmpl">
            <div class="item-dialog ui-widget-dialog commandable exception calendar-reference">
                <div class="dialog-commandable-area">
                    <div class="dialog-commandable-operation">
                        <a href="#" class="operation-button commandable-cancel">Cancel</a>
                    </div>
                </div>
            </div>
        </script>
        <script id="ba-widgets-scheduler-exceptiondialogdaterange-tpl" type="text/x-jquery-tmpl">
            <div class="item-dialog ui-widget-dialog commandable exception range">
                <div class="dialog-commandable-area">
                    <div class="dialog-commandable-operation">
                        <a href="#" class="operation-button commandable-cancel">Cancel</a>
                        <a href="#" class="operation-button commandable-delete">Delete</a>
                    </div>
                </div>
            </div>
        </script>
        <script id="ba-widgets-scheduler-exceptiondialogdate-tpl" type="text/x-jquery-tmpl">
            <div class="item-dialog ui-widget-dialog commandable exception recurring">
                <div class="dialog-commandable-area">
                    <div class="dialog-commandable-operation">
                        <a href="#" class="operation-button commandable-delete">Delete</a>
                        <a href="#" class="operation-button commandable-range">Range</a>
                    </div>
                    <div class="dialog-commandable-value">
                        <div class="value-operation">
                            <a class="value-button down" href="#">&nbsp;</a>
                            <a class="value-button up" href="#">&nbsp;</a>
                        </div>
                        <div class="value-display day">
                            <span class="label static">Day</span>
                            <a href="#" class="value-text day"></a>
                        </div>
                        <div class="value-display month">
                            <span class="label static">Month</span>
                            <a href="#" class="value-text month"></a>
                        </div>
                        <div class="value-display year">
                            <span class="label static">Year</span>
                            <a href="#" class="value-text year"></a>
                        </div>
                    </div>
                    <div class="dialog-commandable-operation">
                        <a href="#" class="operation-button commandable-cancel">Cancel</a>
                        <a href="#" class="operation-button commandable-ok">OK</a>
                    </div>
                </div>
            </div>
        </script>
        <script id="ba-widgets-scheduler-exceptiondialogweeknday-tpl" type="text/x-jquery-tmpl">
            <div class="item-dialog ui-widget-dialog commandable exception week-day">
                <div class="dialog-commandable-area">
                    <div class="dialog-commandable-operation">
                        <a href="#" class="operation-button commandable-delete">Delete</a>
                    </div>
                    <div class="dialog-commandable-value">
                        <div class="value-operation">
                            <a class="value-button down" href="#">&nbsp;</a>
                            <a class="value-button up" href="#">&nbsp;</a>
                        </div>
                        <div class="value-display month">
                            <span class="label static">Month</span>
                            <a href="#" class="value-text month"></a>
                        </div>
                        <span class="label between">of</span>
                        <div class="value-display week">
                            <span class="label static">Week</span>
                            <a href="#" class="value-text week"></a>
                        </div>
                        <div class="value-display day">
                            <span class="label static">Day</span>
                            <a href="#" class="value-text day adjusting"></a>
                        </div>
                        <span class="label leading">Every</span>
                    </div>
                    <div class="dialog-commandable-operation">
                        <a href="#" class="operation-button commandable-cancel">Cancel</a>
                        <a href="#" class="operation-button commandable-ok">OK</a>
                    </div>
                </div>
            </div>
        </script>
        <script id="ba-widgets-toolsarea-tpl" type="text/x-jquery-tmpl">
            <div id="property-view">
            </div>
            <div id="page-navigation">
                <a href="#" class="page-prev down-button"></a>
                <span class="page-number"></span>
                <a href="#" class="page-next up-button"></a>
            </div>
            <div class="related-function">
                <a href="#" class="function-button wide alarm-ack hidden" data-trans="DIALOG_TEXT_MEDIUM_SHORT.ACKNOWLEDGE">Acknowledge</a>
                <a href="#" class="function-button wide alarm-reset hidden" data-trans="DIALOG_TEXT_MEDIUM_SHORT.RESET">Reset</a>
                <a href="#" class="function-button wide two-lines alarm-ack-reset hidden" data-trans="DIALOG_TEXT_LONG.ACK_AND_RESET">Acknowledge and reset</a>
                <a href="#" class="function-button gradient weekly-overview hidden" data-trans="DIALOG_TEXT_SHORT.SCHEDULER_OVERVIEW">Scheduler</a>
                <a href="#" class="function-button gradient exception-list hidden" data-trans="DIALOG_TEXT_SHORT.EXCEPTION_LIST">List View</a>
                <a href="#" class="function-button gradient exception-calendar hidden" data-trans="DIALOG_TEXT_SHORT.EXCEPTION_CALENDAR">Calendar</a>
            </div>
        </script>

        <!-- ---------------- template definitions end ---------------- -->
`;
    }
}
